<template>
  <div>
    <div class="gameplay_points">
      <p>{{ getTranslations.home_game_header_win }}</p>
      <b>{{ pointsPerMiniGame }} {{ getTranslations.home_game_header_points }}</b>
    </div>

    <div class="gameplay_score">
      <p>{{ getTranslations.home_game_header_current_score }}</p>
      <b>{{ totalUserPoints }}</b>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'gameHeader',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'totalUserPoints',
      'pointsPerMiniGame',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/GameHeader.vue